module.exports = __webpack_public_path__ + "static/img/bg_img04.8a37d478.png";